import { configureStore } from '@reduxjs/toolkit';
import secureAccountsReducer from './secureAccountsSlice';
import settingsReducer from './settingsSlice';
import usersReducer from './usersSlice';
import marketingAssetsReducer from './marketingAssetsSlice';

const store = configureStore({
  reducer: {
    secureAccounts: secureAccountsReducer,
    settings: settingsReducer,
    users: usersReducer,
    marketingAssets: marketingAssetsReducer,
  },
});

export default store;
